// Semantic color classes that work with our theme system
// Use Tailwind gradient utility classes with two-tone gradients on opposite spectrum
// Each entry is a string of classes for a gradient background
const gradientClasses = [
  'bg-linear-to-tr from-pink-500 to-blue-500',
  'bg-linear-to-tr from-purple-500 to-yellow-400',
  'bg-linear-to-tr from-indigo-500 to-amber-500',
  'bg-linear-to-tr from-blue-500 to-fuchsia-500',
  'bg-linear-to-tr from-cyan-500 to-rose-500',
  'bg-linear-to-tr from-teal-500 to-orange-400',
  'bg-linear-to-tr from-lime-500 to-violet-500',
  'bg-linear-to-tr from-yellow-500 to-sky-500',
  'bg-linear-to-tr from-amber-500 to-stone-500',
  'bg-linear-to-tr from-fuchsia-500 to-zinc-500',
  'bg-linear-to-tr from-rose-500 to-neutral-500',
  'bg-linear-to-tr from-violet-500 to-emerald-400',
  'bg-linear-to-tr from-sky-500 to-red-400',
  'bg-linear-to-tr from-stone-500 to-pink-500',
  'bg-linear-to-tr from-zinc-500 to-blue-400',
  'bg-linear-to-tr from-neutral-500 to-orange-400',
  'bg-linear-to-tr from-orange-400 to-cyan-500',
  'bg-linear-to-tr from-blue-400 to-lime-500',
  'bg-linear-to-tr from-emerald-400 to-amber-500',
  'bg-linear-to-tr from-red-400 to-indigo-500',
];

export function getGradientClass(initials: string): string {
  // Simple hash based on initials
  let hash = 0;
  for (let i = 0; i < initials.length; i++) {
    hash = initials.charCodeAt(i) + ((hash << 5) - hash);
  }
  const idx = Math.abs(hash) % gradientClasses.length;
  return gradientClasses[idx];
}